import { Search, PenTool, TrendingUp, RefreshCw } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";

const ICONS = [Search, PenTool, TrendingUp, RefreshCw];

export const Intro = () => {
  const { t } = useLanguage();
  return (
    <section
      id="about"
      data-testid="intro-section"
      className="relative bg-[#F3F4F5] text-[#181B24] pt-16 md:pt-20 pb-16 md:pb-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-12">
        <div className="text-center max-w-5xl mx-auto">
          <p
            data-testid="intro-eyebrow"
            className="font-heading uppercase tracking-[0.2em] text-[#181B24]/70 text-xl md:text-2xl lg:text-3xl mb-5"
          >
            {t.intro.eyebrow}
          </p>
          <h2
            data-testid="intro-headline"
            className="font-heading uppercase font-bold leading-[1.05] tracking-[0.01em] text-4xl sm:text-5xl md:text-6xl lg:text-7xl"
          >
            {t.intro.headlineMain}{" "}
            <span className="gradient-text">{t.intro.headlineAccent}</span>
          </h2>

          <p
            data-testid="intro-paragraph"
            className="mt-8 text-[#181B24]/80 text-base md:text-lg leading-relaxed max-w-3xl mx-auto font-body"
          >
            {t.intro.paragraph}
          </p>
        </div>

        <div
          data-testid="process-cards-grid"
          className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {t.intro.steps.map((s, i) => {
            const Icon = ICONS[i] || Search;
            return (
              <div
                key={s.num}
                data-testid={`process-card-${s.num}`}
                className="group relative rounded-2xl p-7 md:p-8 flex flex-col cursor-pointer transition-all duration-300
                  bg-[#202535] border-2 border-transparent text-white
                  hover:bg-white hover:border-[#FFE21A] hover:text-[#181B24] hover:shadow-[0_20px_50px_rgba(32,37,53,0.12)] hover:-translate-y-1"
              >
                <div className="flex items-start justify-between">
                  <div className="font-heading font-bold text-5xl md:text-6xl transition-colors duration-300 text-white group-hover:text-[#181B24]">
                    {s.num}
                  </div>
                  <div className="w-14 h-14 rounded-full flex items-center justify-center bg-[#FFE21A]">
                    <Icon size={26} className="text-[#181B24]" strokeWidth={2.5} />
                  </div>
                </div>

                <p className="mt-5 font-body text-sm md:text-[0.95rem] leading-snug transition-colors duration-300 text-white/70 group-hover:text-[#181B24]/75">
                  {s.desc}
                </p>

                <div className="mt-5">
                  <div className="font-heading uppercase font-bold tracking-[0.1em] text-2xl md:text-3xl text-[#FFE21A]">
                    {s.title}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Intro;
